import { render } from "./AW23Category.vue?vue&type=template&id=52b8efce&scoped=true"
import script from "./AW23Category.vue?vue&type=script&lang=js"
export * from "./AW23Category.vue?vue&type=script&lang=js"

import "./AW23Category.vue?vue&type=style&index=0&id=52b8efce&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/rb-redev/rb-redev/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-52b8efce"]])

export default __exports__